export default __webpack_public_path__ + "static/image2-2e2f55bdd3ac195e19f2323090407881.webp";